export const StateStatusCssClasses = ["success", "info", ""];
export const StateStatusTitles = ["active", "inactive"];
export const StateConditionCssClasses = ["success", "danger", ""];
export const StateConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "30", value: 30 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const initialFilter = {
  filter: {
    name: "",
    email: "",
    icon: "",
    approval_status:-1,
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 50
};
